module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("chapter 1")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_vm._v("Secrets")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("We")]), _vm._v(" drive across the Minnesota prairie in our old tan and green Volkswagen bus. My father does not believe in new cars. He loves the old Volkswagen with the top that pops up like a tent. He can take the motor apart and fix it himself.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("In the way back are neat wooden ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("framed beds for sleeping. In a pen are Mama’s chickens: Ella, Sofia, and Nickel. Mama loves them and never goes away for long without them. My younger sister, Grace, sits in her car seat next to me. In back of her is Teddy, the youngest, with his stuffed beaver.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indentb"
  }, [_vm._v("My father, called Boots because he wears them, is driving, listening to opera on the radio. It is "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("La Traviata")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Misterioso, misterioso altero . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I know it well. If a conductor dropped dead on stage I could climb up there and conduct.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Now here is something abnormal. I can’t sing. When I open my mouth nothing ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("happens. I know the music, but I can’t sing it. I can only conduct it.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("My father went to Harvard. His parents expected him to be a banker like his father. In secret he planned to be a poet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But then he discovered cows. He became a farmer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He loves cows.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They are poetry, Lucy,” he tells me. “I can’t write anything better than a cow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Maggie, my mother in the front seat, wears headphones. I know she is listening to Langhorne Slim. She loves Langhorne Slim as much as my father loves opera. And I know "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("her")]), _vm._v(" secret. She would like to sing like Langhorne Slim. She would like to "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("be")]), _vm._v(" Langhorne Slim.")])]), _c('p', {
    staticClass: "poemc"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("If you’ve got worries, then you’re like me.")])])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "poemcb"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Don’t worry now, I won’t hurt you.")])]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("My younger sister, Gracie, ignores the opera and my mother’s bopping around in the front seat. Gracie sings in a high perfect voice, fluttering her hands like birds.")]), _vm._v(" "), _c('p', {
    staticClass: "poemc"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“The birdies fly away, and they come back home.")])]), _vm._v(" "), _c('p', {
    staticClass: "poemcb"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("The birdies fly away, and they come back home.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I turn and look at my little brother, Teddy. He smiles at me and I know what that smile is all about.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("In his small head he is singing the “Fly Away” chorus in private so no one can hear.")])]), _c('p', {
    staticClass: "poemc"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Fly away, fly away,")])])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "poemcb"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("All the birdies fly away.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I smile back at him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is our secret because Teddy wants it that way.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("I have known for a long time that Teddy can sing perfectly in tune even though he is not yet two. We all know he doesn’t speak words yet. But only Teddy and I know that he sings. He doesn’t sing the words, but sings every song with "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("“la la la.”")]), _vm._v(" He sings to me every night, climbing out of his bed, padding into my room in the dark. He sings a peppy “Baa, Baa, Black Sheep,” ending with a “Yay” at the end with his hands in the air.")])]), _c('p', {
    staticClass: "poemc"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“La La La La")])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "poemv"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("LaLaLaLaLa.")])]), _vm._v(" "), _c('p', {
    staticClass: "poemcb"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Yay!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He sings a soft, quiet “All the Pretty Horses.” "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("“La, la, la.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I made a mistake once and told them all—Boots, Mama, and Gracie—that Teddy can sing. They didn’t believe me. And of course Teddy wouldn’t sing for them. Only for me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve never heard Teddy sing,” says Gracie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He can’t even talk yet,” says Mama. “How could he sing?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Teddy has music but no words.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have words but no music.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We are a strange pair.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("And here is "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("my")]), _vm._v(" secret: I am planning to be a poet. I have written thirty-one and a half poems. Some are bad. They are bad hideaway poems. I plan to get better and publish better poems and buy Mama more chickens and take Boots to see "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("La Traviata")]), _vm._v(" at the opera house in New York City, wherever New York City is.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("When I get to be a poet Boots will be pleased.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He will be proud.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And one day, for him, I will write a poem as beautiful as a cow.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-728235ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 66
// module chunks = 0